import { ApiType } from "@gymflow/common";
import { MembershipSignupPaymentMethodRequestBody } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiV2 } from "../../apiV2";
import { memberQueryKeys } from "../member";
import { productQueryKeys } from "../product";
import { sales } from "./sales";

export function useMutationMembershipSignupPaymentMethod({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: MembershipSignupPaymentMethodRequestBody) =>
      (await api.salesApi.membershipSignupPaymentMethod(body)).data,
    onSuccess: (data, { userMemberId }) => {
      queryClient.invalidateQueries({
        queryKey: sales.all(),
      });
      queryClient.invalidateQueries({
        queryKey: memberQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: productQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.subscription.keys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.wallet.keys.list(userMemberId),
      });
    },
  });
}
